import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { isAuthAdmin } from "../../../../../services/auth";
import { Button, Form, Input, Divider } from "semantic-ui-react";
import TextEditor from "../../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";

import { Container, Content, Title, Field, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../Back";

const CriarFaq = props => {
  const description = useRef("");
  const [faqTipo, setFaqTipo] = useState([]);
  const [pergunta, setPergunta] = useState("");
  const [tipo, setTipo] = useState(0);

  useEffect(() => {
    loadAuth();
    loadFaqTipo();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadFaqTipo = async () => {
    await api
      .get(`/faq-categorias`)
      .then(res => {
        console.log("FAQ CATEGORIAS::", res.data);

        setFaqTipo(res.data);
      })
      .catch(err => {
        swal("Não foi possível carregar as categorias de tipo", err, "error");
      });
  };

  const handleCreateFaq = async () => {
    const payload = {
      pergunta: pergunta,
      resposta: description.current,
      tipo: tipo,
    };

    const faqValidation = await yup.object().shape({
      pergunta: yup
        .string("Necessário que informe a pergunta")
        .required("Necessário que informe a pergunta"),
      resposta: yup
        .string("Necessário que informe a resposta")
        .required("Necessário que informe a resposta"),
      tipo: yup
        .number("Necessário que informe o tipo")
        .required("Necessário que informe o tipo"),
    });

    try {
      await faqValidation.validate(payload, { abortEarly: true });
      api
        .post(`/admin/faq`, payload)
        .then(async res => {
          let logs = {
            local: "admin/faq/criar",
            texto: `criou a FAQ de id ${res.data.faq.id}`,
          };
          await api.post("system_logs", { acao: JSON.stringify(logs) });
          swal("Faq salva com sucesso", "", "success").then(res =>
            props.history.push("/admin/faq")
          );
        })
        .catch(err => {
          swal("Não foi possível salvar a faq", err, "").then(res =>
            props.history.push("/admin/faq")
          );
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back actualPage={"Criar novo FAQ"} />

          <Title>Criar Faq</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field>
                <Label>Pergunta</Label>
                <input
                  placeholder="Pergunta"
                  value={pergunta}
                  name="pergunta"
                  onChange={e => setPergunta(e.target.value)}
                />
              </Form.Field>
              <Form.Field>
                <Label>Tipo</Label>
                <select onChange={e => setTipo(+e?.target?.value)}>
                  {faqTipo.map(valor => (
                    <option value={valor.id}>{valor.segmento}</option>
                  ))}
                </select>
              </Form.Field>
            </Form.Group>

            <Field>
              <Label>Resposta</Label>
              <TextEditor
                haveFullscreen
                default={description.current}
                text={description}
              />
            </Field>
            <Divider hidden />
            <Form.Group>
              <Form.Field control={Button} onClick={() => handleCreateFaq()}>
                Enviar
              </Form.Field>
              <Link to="/admin/banner/faq">
                <Button color="secondary">Cancelar</Button>
              </Link>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CriarFaq);
